import React from 'react';
import { observer } from 'mobx-react';
import Facebook from 'js/services/Facebook';
import {makeRequest, url} from 'js/services/Network';
import { lightGrey1Color } from 'js/config/style';
import styled from 'styled-components';
import analytics from 'js/services/Analytics';

import StoreActivationPageState from 'js/stores/pages/StoreActivationPageState';

import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import { Link } from '@reach/router';

const MainContent = styled.div`
  background-color: white;
  padding: 1em;
`;

@observer
class StoreActivationPage extends PageComponent {
  pageName = 'StoreActivationPage';
  trackingName = 'SP_mseller_store_activated';
  loginRequired = true;
  pageColor = lightGrey1Color;
  page = StoreActivationPageState.create();
  pageWidth = '600px';

  constructor(props) {
    super(props);
  }

  bootstrap = () => this.page.load(true).then(() => {/*analytics.page('Store Activation Page')*/});

  onAction = () => {
    const { owner_name, micro_store_url: url } = this.page;
    if (navigator.share) {
      navigator.share({
        title: `${owner_name}'s Store`,
        url,
        text: `Here is my delivery link, you can pay there and arrange delivery`,
      });
    } else {

      analytics.track('CTA_SP_mseller_store_activated_share', {
        'Event Initiated by': 'mseller',
        'Micro Store URL': url
      });

      Facebook.ui({
        method: 'share',
        href: url,
      });
    }
  }

  pageEvent = () => {
    makeRequest('push-psp-intro-mail',null,'')
      .then(response => {
        console.log("response ",response.data)
      })
      .catch(error => {
        console.log("error ",error)
      });
  }

  handleLinkClick = (event) => {
    const { owner_name, micro_store_url: url } = this.page;
    console.log('this.page',this.page);
    analytics.track('CTA_SP_mseller_store_activated_dashboard', {
      'Event Initiated by': 'mseller',
      'Micro Store URL': url
    });
  };

  renderPage() {

    return (
      <AppContent className="store-actvation-page">
        <MainContent className="pod-container mt-4 d-flex flex-column justify-content-center align-items-center">
          <img
            className="mb-4"
            src="/images/v2/confirmation-icon-stars.svg" alt="store activation confirmed"
          />
          <div className="headline mb-4">
            <h3 className="text-center m-0">
              <strong>Congratulations, {this.page.owner_name}!</strong>
            </h3>
            <h3 className="text-center">
              <strong>You've successfully activated your store</strong>
            </h3>
          </div>
          <p className="text-center mb-5">
            You can now share the link to your store with your network.
          </p>
          <div className="options d-flex flex-md-row flex-column justify-content-center align-items-center">
            <button
              className="btn btn-pod btn-primary m-1"
              onClick={() => this.onAction()}
            >
              Share your store
            </button>
            <Link
              className="btn btn-pod btn-third m-1"
              to={url('user-dashboard-page')}
              onClick={this.handleLinkClick}
            >
              Go to store dashboard
            </Link>
          </div>
        </MainContent>
      </AppContent>
    );
  }
}
export default StoreActivationPage;
